import React from 'react';
//export const PAGE_TITLE_DEFAULT_VALUE = ;
const PageTitleContext = React.createContext();

export default PageTitleContext;
